import { Avatar, AvatarStaticIcon, type AvatarSize } from "@/components/Avatar";
import type { FC } from "react";
import IconCuteRobotBase from "central-icons/IconCuteRobot";
import { withGitpodSize } from "@/assets/icons/utils";

const IconCuteRobot = withGitpodSize(IconCuteRobotBase);

export const ServiceAccountAvatar: FC<{ id: string; size?: AvatarSize }> = ({ id, size }) => {
    return (
        <Avatar size={size}>
            <AvatarStaticIcon identifier={id} size={size}>
                <IconCuteRobot size="sm" />
            </AvatarStaticIcon>
        </Avatar>
    );
};
